import {ApiService} from "../index";
import {APIConfig} from "../../../constants";
import moment from "moment";

const today = moment();
const weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const injurySeverityLevels = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const AuthorizedRecords: string[] = ['care_plan', 'lab_and_radiology_reports','complete_medical_record','medication_records','consultation_reports','operative_reports','exercise_records', 'pathology_reports', 'history_and_physical', 'progress_notes', 'hospital_reports', 'other'];
const yesNoOptions = [{
    title: "Yes",
    code: true
}, {
    title: "No",
    code: false
}];

const options = [
    {
        label: 'Yes – I give permission for my information to be disclosed to the people or entity listed below.',
        value: true,
    },
    {
        label: 'No – I do not consent to the disclosure of my information to any individual or entity, except as required by law or as outlined in KINERGY’s Notice of Privacy Practices.',
        value: false,
    }
]

const resultOptions = [{
    title: "Positive",
    code: "Positive"
}, {
    title: "Negative",
    code: "Negative"
}];

const bodyRegion = [
    {
        title: "Whole_Body",
        code: false
    },
    {
        title: "Upper_Body",
        code: false
    },
    {
        title: "Lower_Body",
        code: false
    },
    {
        title: "Trunk/Core",
        code: false
    }
]

const getConsultationDurationList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.CONSULTATION_DURATION_LIST.METHOD](APIConfig.CONSULTATION_DURATION_LIST.URL, payload);
}

const getGenderList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GENDER_LIST.METHOD](APIConfig.GENDER_LIST.URL, payload);
}

const getPhoneTypeList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.PHONE_TYPE_LIST.METHOD](APIConfig.PHONE_TYPE_LIST.URL, payload);
}

const getLanguageList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.LANGUAGE_LIST.METHOD](APIConfig.LANGUAGE_LIST.URL, payload);
}

const getEmployeeStatusList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.EMPLOYMENT_STATUS_LIST.METHOD](APIConfig.EMPLOYMENT_STATUS_LIST.URL, payload);
}

const getRelationshipStatusList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.RELATIONSHIP_LIST.METHOD](APIConfig.RELATIONSHIP_LIST.URL, payload);
}

const getMedicalHistoryOptionsList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.MEDICAL_HISTORY_OPTIONS_LIST.METHOD](APIConfig.MEDICAL_HISTORY_OPTIONS_LIST.URL, payload);
}

const getSurgicalHistoryOptionsList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SURGICAL_HISTORY_OPTIONS_LIST.METHOD](APIConfig.SURGICAL_HISTORY_OPTIONS_LIST.URL, payload);
}

const getMusculoskeletalHistoryOptionsList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.MUSCULOSKELETAL_HISTORY_OPTIONS_LIST.METHOD](APIConfig.MUSCULOSKELETAL_HISTORY_OPTIONS_LIST.URL, payload);
}


const getSocialMediaPlatformList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SOCIAL_MEDIA_PLATFORM_LIST.METHOD](APIConfig.SOCIAL_MEDIA_PLATFORM_LIST.URL, payload);
}

const getReferralTypeList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.REFERRAL_TYPE_LIST.METHOD](APIConfig.REFERRAL_TYPE_LIST.URL, payload);
}

const getCommunicationModeTypeList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.COMMUNICATION_MODE_TYPE_LIST.METHOD](APIConfig.COMMUNICATION_MODE_TYPE_LIST.URL, payload);
}

const getBodyPartList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.BODY_PART_LIST.METHOD](APIConfig.BODY_PART_LIST.URL, payload);
}

const getInjuryTypeList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.INJURY_TYPE_LIST.METHOD](APIConfig.INJURY_TYPE_LIST.URL, payload);
}

const getCaseStatusList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.CASE_STATUS_LIST.METHOD](APIConfig.CASE_STATUS_LIST.URL, payload)
}

const getProgressReportStatList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.PROGRESS_REPORT_STATS_LIST.METHOD](APIConfig.PROGRESS_REPORT_STATS_LIST.URL, payload)
}

const get8MinuteRuleChartData = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.CLIENT_EIGHT_MINUTES_RULE_CHART.METHOD](APIConfig.CLIENT_EIGHT_MINUTES_RULE_CHART.URL, payload)
}

const getConcussionFileTypes = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.CONCUSSION_FILE_TYPES.METHOD](APIConfig.CONCUSSION_FILE_TYPES.URL, payload)
}

const getMedicalRecordDocumentTypes = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.MEDICAL_RECORD_DOCUMENT_TYPES.METHOD](APIConfig.MEDICAL_RECORD_DOCUMENT_TYPES.URL, payload)
}

const getAppointmentStatusList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.APPOINTMENT_STATUS_LIST.METHOD](APIConfig.APPOINTMENT_STATUS_LIST.URL, payload)
}

const getPaymentModes = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.PAYMENT_MODES.METHOD](APIConfig.PAYMENT_MODES.URL, payload)
}
const getAccessibleAccounts = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ACCESSIBLE_ACCOUNTS.METHOD](APIConfig.ACCESSIBLE_ACCOUNTS.URL, payload)
}
const getDocumentFileTypesList = () => {
    // @ts-ignore
    return ApiService[APIConfig.DOCUMENT_FILE_TYPES.METHOD](APIConfig.DOCUMENT_FILE_TYPES.URL)
}
const getDocumentTypesList = () => {
    // @ts-ignore
    return ApiService[APIConfig.DOCUMENT_TYPES_LIST.METHOD](APIConfig.DOCUMENT_TYPES_LIST.URL)
}

const getAllFacilityList = () => {
    // @ts-ignore
    return ApiService[APIConfig.GET_FACILITY_LIST.METHOD](APIConfig.GET_FACILITY_LIST.URL)
}

export const getPhysicalActivityFrequency = (payload: any) => {
    return ApiService[APIConfig.PHYSICAL_ACTIVITY_FREQUENCY.METHOD](APIConfig.PHYSICAL_ACTIVITY_FREQUENCY.URL, payload);
};

export const getPhysicalActivityIntensity = (payload: any) => {
    return ApiService[APIConfig.PHYSICAL_ACTIVITY_INTENSITY.METHOD](APIConfig.PHYSICAL_ACTIVITY_INTENSITY.URL, payload);
};

export const getPhysicalActivityFrequencyForHeartRateImpact = (payload: any) => {
    return ApiService[APIConfig.PHYSICAL_ACTIVITY_FREQUENCY_FOR_HEART_RATE_IMPACT.METHOD](
        APIConfig.PHYSICAL_ACTIVITY_FREQUENCY_FOR_HEART_RATE_IMPACT.URL, payload
    );
};

export const getPhysicalActivityExerciseCapacity = (payload: any) => {
    return ApiService[APIConfig.PHYSICAL_ACTIVITY_EXERCISE_CAPACITY.METHOD](APIConfig.PHYSICAL_ACTIVITY_EXERCISE_CAPACITY.URL, payload);
};

export const getPhysicalActivityTypes = (payload: any) => {
    return ApiService[APIConfig.PHYSICAL_ACTIVITY_TYPES.METHOD](APIConfig.PHYSICAL_ACTIVITY_TYPES.URL, payload);
};

export const getWeightUnits = (payload: any) => {
    return ApiService[APIConfig.WEIGHT_UNITS.METHOD](APIConfig.WEIGHT_UNITS.URL, payload);
};

export const getHeightUnits = (payload: any) => {
    return ApiService[APIConfig.HEIGHT_UNITS.METHOD](APIConfig.HEIGHT_UNITS.URL, payload);
};

const StaticDataService = {
    today,
    weekDays,
    yesNoOptions,
    resultOptions,
    injurySeverityLevels,
    getConsultationDurationList,
    getGenderList,
    getPhoneTypeList,
    getEmployeeStatusList,
    getLanguageList,
    getRelationshipStatusList,
    getMedicalHistoryOptionsList,
    getSurgicalHistoryOptionsList,
    getMusculoskeletalHistoryOptionsList,
    getSocialMediaPlatformList,
    getReferralTypeList,
    getCommunicationModeTypeList,
    getBodyPartList,
    getInjuryTypeList,
    getCaseStatusList,
    getProgressReportStatList,
    get8MinuteRuleChartData,
    getConcussionFileTypes,
    getAppointmentStatusList,
    getMedicalRecordDocumentTypes,
    getPaymentModes,
    getAccessibleAccounts,
    getDocumentFileTypesList,
    getAllFacilityList,
    getDocumentTypesList,
    options,
    AuthorizedRecords,
    bodyRegion,
    getPhysicalActivityFrequency,
    getPhysicalActivityIntensity,
    getPhysicalActivityFrequencyForHeartRateImpact,
    getPhysicalActivityExerciseCapacity,
    getPhysicalActivityTypes,
    getWeightUnits,
    getHeightUnits,
}

export default StaticDataService;
